import { Navigate, createBrowserRouter, useLocation, useParams } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';

import { AuthGate, GuestOnlyGate } from '../components/layout/AuthGate';
import { AuthLayout } from '../components/layout/AuthLayout';
import { MainLayout } from '../components/layout/MainLayout';
import { DangNhapView } from '../modules/auth/views/DangNhapView';
import { ChungTuView } from '../modules/xu-ly/views/ChungTuView';
import { NhanDangView } from '../modules/xu-ly/views/NhanDangView';
import { ChonKhuonView } from '../modules/xu-ly/views/ChonKhuonView';
import { ChiTietChungTuView } from '../modules/xu-ly/views/ChiTietChungTuView';
import { DanhSachLoaiChungTuView } from '../modules/cau-hinh-ocr/views/DanhSachLoaiChungTuView';
import { ChiTietLoaiChungTuView } from '../modules/cau-hinh-ocr/views/ChiTietLoaiChungTuView';
import { KhoOcrView } from '../modules/kho-ocr/views/KhoOcrView';
import { ManHinhModuleView } from '../modules/module-da-cai/views/ManHinhModuleView';
import { ModuleToChucView } from '../modules/module-to-chuc/views/ModuleToChucView';
import { DashboardView } from '../modules/dashboard/views/DashboardView';
import { BaoCaoView } from '../modules/bao-cao/views/BaoCaoView';
import { TokenAiView } from '../modules/token-ai/views/TokenAiView';
import { CaiDatBaoMatView } from '../modules/bao-mat/views/CaiDatBaoMatView';
import { LicenseCucBoView } from '../modules/license-cuc-bo/views/LicenseCucBoView';
import { CauHinhNguoiDungView } from '../modules/nguoi-dung/views/CauHinhNguoiDungView';
import { CauHinhVaiTroView } from '../modules/vai-tro/views/CauHinhVaiTroView';
import { KhoaApiView } from '../modules/khoa-api/views/KhoaApiView';
// Đặc tả chức năng module của tenant mục 7 (ADR-0117): tổ chức tự nộp gói plugin rồi cài để dùng.
import { CanhBaoTenantView } from '../modules/canh-bao/views/CanhBaoTenantView';
import { DiaChiRiengView } from '../modules/dia-chi-rieng/views/DiaChiRiengView';
import { CoCauToChucView } from '../modules/co-cau-to-chuc/views/CoCauToChucView';
import { TaiKhoanCuaToiView } from '../modules/tai-khoan/views/TaiKhoanCuaToiView';
import { GiaoDienView } from '../modules/giao-dien/views/GiaoDienView';
import { ChiTietKhoView } from '../modules/tri-thuc/views/ChiTietKhoView';
import { ChiTietHoSoView } from '../modules/tham-dinh/views/ChiTietHoSoView';
import { HoSoThamDinhView } from '../modules/tham-dinh/views/HoSoThamDinhView';
import { PheDuyetThamDinhView } from '../modules/tham-dinh/views/PheDuyetThamDinhView';
import { ThuVienTieuChiView } from '../modules/tham-dinh/views/ThuVienTieuChiView';
import { TichHopApiView } from '../modules/tham-dinh/views/TichHopApiView';
import { TongQuanThamDinhView } from '../modules/tham-dinh/views/TongQuanThamDinhView';
import { ChiTietHoSoDinhDanhView } from '../modules/ekyc/views/ChiTietHoSoDinhDanhView';
import { DinhDanhView } from '../modules/ekyc/views/DinhDanhView';
import { HoSoDinhDanhView } from '../modules/ekyc/views/HoSoDinhDanhView';
import { QuyTrinhView } from '../modules/ekyc/views/QuyTrinhView';
import { TongQuanEkycView } from '../modules/ekyc/views/TongQuanEkycView';
import { UngDungView } from '../modules/ekyc/views/UngDungView';
import { KhoTriThucView } from '../modules/tri-thuc/views/KhoTriThucView';
import { KiemDuyetView } from '../modules/tri-thuc/views/KiemDuyetView';
import { UploadTaiLieuView } from '../modules/tri-thuc/views/UploadTaiLieuView';
import { NguonView } from '../modules/bao-cao-doanh-nghiep/views/NguonView';
import { PhanHeView } from '../modules/bao-cao-doanh-nghiep/views/PhanHeView';
import { TaiLieuView } from '../modules/bao-cao-doanh-nghiep/views/TaiLieuView';
import { SLUG_PHAN_HE } from '../modules/bao-cao-doanh-nghiep/types';
import { CauHinhDauVaoView } from '../modules/xu-ly-van-ban/views/CauHinhDauVaoView';
import { MauVanBanView } from '../modules/xu-ly-van-ban/views/MauVanBanView';
import { VaiTroCacCapView } from '../modules/xu-ly-van-ban/views/VaiTroCacCapView';
import { TomTatView } from '../modules/xu-ly-van-ban/views/TomTatView';
import { SoanThaoView } from '../modules/xu-ly-van-ban/views/SoanThaoView';
import { PhanCongView } from '../modules/xu-ly-van-ban/views/PhanCongView';
import { QuanLyNhiemVuView } from '../modules/xu-ly-van-ban/views/QuanLyNhiemVuView';
import { ThongBaoView } from '../modules/xu-ly-van-ban/views/ThongBaoView';
import { BotChatView } from '../modules/tro-ly-ai/views/BotChatView';
import { BotLuoiView } from '../modules/tro-ly-ai/views/BotLuoiView';
import { ChatbotConfigView } from '../modules/tro-ly-ai/views/ChatbotConfigView';
import { ChuyenSangKhuon, ChuyenSangTroChuyen } from '../modules/tro-ly-ai/views/ChuyenHuong';
import { DataPermView } from '../modules/tro-ly-ai/views/DataPermView';
import { HoiDapView } from '../modules/tro-ly-ai/views/HoiDapView';
import { KetNoiView } from '../modules/tro-ly-ai/views/KetNoiView';
import { KhoDuLieuView } from '../modules/tro-ly-ai/views/KhoDuLieuView';
import { KhuonChiTietView } from '../modules/tro-ly-ai/views/KhuonChiTietView';
import { KhuonView } from '../modules/tro-ly-ai/views/KhuonView';
import { PlaygroundView } from '../modules/tro-ly-ai/views/PlaygroundView';
import { ReplicaView } from '../modules/tro-ly-ai/views/ReplicaView';
import { TongQuanTroLyView } from '../modules/tro-ly-ai/views/TongQuanTroLyView';
import { TracesView } from '../modules/tro-ly-ai/views/TracesView';
import { AgentView as AgentRpaView } from '../modules/rpa/views/AgentView';
import { CauHinhLoiView } from '../modules/rpa/views/CauHinhLoiView';
import { DuLieuThucThiView } from '../modules/rpa/views/DuLieuThucThiView';
import { LicenseView } from '../modules/rpa/views/LicenseView';
import { LichSuView } from '../modules/rpa/views/LichSuView';
import { ProjectView } from '../modules/rpa/views/ProjectView';
import { SuCoView } from '../modules/rpa/views/SuCoView';
import { TongQuanView as TongQuanRpaView } from '../modules/rpa/views/TongQuanView';
import { UserOpenCoreView } from '../modules/rpa/views/UserOpenCoreView';
import { WorkflowView } from '../modules/rpa/views/WorkflowView';
import { NAV_SECTIONS } from '../components/layout/nav-config';
import { DUONG_CU, MODULES } from '../app/modules';
import { ChuyenDuongCu, RouteModule, VeModuleDauTien } from '../app/RouteModule';
import { TIEN_TO } from '../lib/duong-dan-cong';
import { useDuongDan } from '../hooks/useDuongDan';
import { ChuaDungPage, KhongTimThayPage, StubPage } from './StubPage';
import type { KhoaDich } from '../i18n';

/** Bốn route chỉ có tiêu đề (§3.5). */
const STUB_ROUTES: ReadonlyArray<readonly [string, KhoaDich]> = [
  ['/xu-ly/hop-dong', 'chungTu.loai.HDBL'],
  ['/xu-ly/phieu-nhap-kho', 'chungTu.loai.PNK'],
  ['/tri-thuc/ket-noi', 'nav.muc.ketNoiDuLieuTuDong'],
  ['/tri-thuc/ocr-chuan-hoa', 'nav.muc.ocrChuanHoa'],
];

/**
 * Màn nghiệp vụ đã dựng trong lần giao này (Phase 5 của §18.1).
 *
 * Mọi đường dẫn ở tệp này là **đường dẫn gốc**, không mang tiền tố cổng. Tiền
 * tố được ghép ở `duoiTienTo()` ngay phía dưới — viết thẳng `/client/...` vào
 * đây là ghim màn vào một cổng và làm hỏng chế độ xem chéo của nhân sự nền
 * tảng (ADR-UI-0012).
 */
const BUILT_ROUTES = new Set([
  '/token-ai',
  '/bao-cao',
  '/xu-ly/chung-tu',
  '/xu-ly/nhan-dang',
  '/xu-ly/tai-lieu-ocr',
  '/xu-ly/cau-hinh-ocr',
  '/he-thong/bao-mat',
  '/he-thong/license',
  '/he-thong/nguoi-dung',
  '/he-thong/vai-tro',
  '/tri-thuc',
  '/tri-thuc/kiem-duyet',
  '/tri-thuc/upload',
  '/he-thong/khoa-api',
  // ADR-0102: trung tâm thông báo của tổ chức.
  '/he-thong/canh-bao',
  // ADR-0097 mục 2: Tenant Admin tự gán domain thương hiệu.
  '/he-thong/dia-chi-rieng',
  '/he-thong/to-chuc',
  // ADR-0080 đợt 1: module tham-dinh. Thiếu dòng ở đây thì placeholderRoutes() vẫn sinh stub cho
  // năm đường dẫn này và stub thắng, vì nó được nối sau trong mảng route.
  '/tham-dinh',
  '/tham-dinh/ho-so',
  '/tham-dinh/ho-so/:id',
  '/tham-dinh/phe-duyet',
  '/tham-dinh/tieu-chi',
  '/tham-dinh/tich-hop',
  /*
   * Module eKYC (Định danh eKYC): sáu màn. Thiếu một dòng ở đây thì `placeholderRoutes()` vẫn sinh stub
   * cho mục nav tương ứng, và stub **thắng** vì nó được nối sau trong mảng route.
   */
  '/ekyc',
  '/ekyc/dinh-danh',
  '/ekyc/ho-so',
  '/ekyc/ho-so/:id',
  '/ekyc/quy-trinh',
  '/ekyc/ung-dung',
  // GN-D2-3 đến GN-D2-5 (ADR-0073): Cấu hình xử lý văn bản, module van-ban; đường dẫn theo ADR-UI-0015
  '/xu-ly-van-ban/cau-hinh/dau-vao',
  '/xu-ly-van-ban/cau-hinh/mau-van-ban',
  '/xu-ly-van-ban/cau-hinh/vai-tro-cac-cap',
  /*
   * ADR-0081, module bao-cao: đủ 7 đường dẫn. Thiếu một đường thì `placeholderRoutes()` vẫn sinh route tĩnh
   * `ChuaDungPage` cho mục nav đó, và React Router xếp đoạn tĩnh trên đoạn động — màn thật không bao giờ hiện.
   */
  ...SLUG_PHAN_HE.map((slug) => `/bao-cao-doanh-nghiep/${slug}`),
  '/bao-cao-doanh-nghiep/tai-lieu',
  '/bao-cao-doanh-nghiep/nguon',
  // GN-D2-9 đến GN-D2-12 (ADR-0084): Xử lý văn bản, module van-ban
  '/xu-ly-van-ban/tom-tat',
  '/xu-ly-van-ban/soan-thao',
  '/xu-ly-van-ban/phan-cong',
  '/xu-ly-van-ban/quan-ly-nhiem-vu',
  '/thong-bao',
  /*
   * ADR-0086, module tro-ly-ai: mười hai màn của Trợ lý AI. Thiếu một dòng ở đây thì `placeholderRoutes()` vẫn sinh
   * `ChuaDungPage` cho mục nav đó và stub thắng.
   */
  '/tro-ly-ai',
  '/tro-ly-ai/tong-quan',
  '/tro-ly-ai/tro-chuyen',
  '/tro-ly-ai/ket-noi',
  '/tro-ly-ai/ban-sao',
  '/tro-ly-ai/khuon',
  '/tro-ly-ai/cong-cu-api',
  '/tro-ly-ai/quyen-du-lieu',
  '/tro-ly-ai/chatbot',
  '/tro-ly-ai/nhat-ky',
  '/tro-ly-ai/thu-nghiem',
  // ADR-0103, module rpa: màn đã dựng. Thiếu một dòng thì placeholderRoutes() sinh ChuaDungPage và stub thắng.
  '/rpa',
  '/rpa/agent',
  '/rpa/projects',
  '/rpa/workflows',
  '/rpa/alert-config',
  '/rpa/history',
  '/rpa/history/execution-data',
  '/rpa/incidents',
  '/rpa/licenses',
  '/rpa/opencore-users',
  // ADR-0096 mục 8: màn Module của cổng tenant.
  '/module',
  ...STUB_ROUTES.map(([path]) => path),
]);

/**
 * Sinh route giữ chỗ cho **mọi** mục trong cây điều hướng chưa được dựng.
 *
 * Nhờ vậy thanh điều hướng không bao giờ dẫn tới trang trắng: bấm vào mục nào
 * cũng ra một màn có khung và PageHeader, nói rõ màn đó thuộc giai đoạn nào.
 */
function placeholderRoutes(): RouteObject[] {
  const seen = new Set(BUILT_ROUTES);
  const routes: RouteObject[] = [];

  for (const section of NAV_SECTIONS) {
    for (const item of section.items) {
      const targets = item.children ?? [item];
      for (const target of targets) {
        if (!target.href || seen.has(target.href)) continue;
        seen.add(target.href);
        routes.push({
          path: target.href,
          element: <ChuaDungPage khoa={target.khoa} />,
        });
      }
    }
  }

  // Những màn không có mục nav nhưng vào được bằng URL (§6.1).
  const extra: ReadonlyArray<readonly [string, KhoaDich]> = [
    ['/he-thong/phan-he', 'route.cauHinhPhanHe'],
    ['/he-thong/phan-quyen-tai-nguyen', 'route.phanQuyenTaiNguyen'],
    ['/xu-ly/hoa-don-vat', 'route.hoaDonVatDauVao'],
  ];
  for (const [path, khoa] of extra) {
    if (seen.has(path)) continue;
    seen.add(path);
    routes.push({ path, element: <ChuaDungPage khoa={khoa} /> });
  }

  return routes;
}

/**
 * Đường dẫn cũ của cổng tenant → đường dẫn mới, cùng là đường dẫn gốc.
 *
 * Bản tenant của `DUONG_CU` ở registry: `DUONG_CU` chỉ chuyển sang màn của cổng nền tảng (`TIEN_TO['nen-tang']`),
 * còn cổng tenant chưa có registry riêng nên khai ở đây, cạnh các route của nó. Giữ để dấu trang và liên kết đã
 * gửi đi không thành 404. Đường cũ kết thúc bằng `/*` thì phần đuôi (`:schemaId`) đi theo sang đường mới.
 *
 * Người vào đường cũ vẫn qua `PermissionGuard` trước khi chuyển; đường mới lại được xét theo dịch vụ của nó, nên
 * tenant không thuê dịch vụ đó gặp 403 ở đường mới chứ không lọt vào màn.
 */
const DUONG_CU_TENANT: ReadonlyArray<readonly [string, string]> = [
  // ADR-UI-0015: màn cấu hình của dịch vụ chuyển từ nhóm Cấu hình hệ thống về nhóm của dịch vụ.
  ['he-thong/xu-ly-van-ban/cau-hinh-dau-vao', '/xu-ly-van-ban/cau-hinh/dau-vao'],
  ['he-thong/xu-ly-van-ban/mau-van-ban', '/xu-ly-van-ban/cau-hinh/mau-van-ban'],
  ['he-thong/xu-ly-van-ban/vai-tro-cac-cap', '/xu-ly-van-ban/cau-hinh/vai-tro-cac-cap'],
  ['he-thong/ocr/*', '/xu-ly/cau-hinh-ocr'],
  // Bỏ nhóm Nhật ký & Truy vết của tổ chức: nhật ký sử dụng AI thành một thẻ của Cài đặt bảo mật, các màn còn lại đã
  // có ở Cài đặt bảo mật (nhật ký, cảnh báo); giá và hạn mức AI do nền tảng quản lý.
  ['nhat-ky/su-dung-ai', '/he-thong/bao-mat?the=su-dung-ai'],
  ['nhat-ky/tong-quan', '/he-thong/bao-mat?the=nhat-ky'],
  ['nhat-ky/thao-tac', '/he-thong/bao-mat?the=nhat-ky'],
  ['nhat-ky/canh-bao', '/he-thong/bao-mat?the=nhat-ky'],
  ['nhat-ky/cau-hinh', '/he-thong/bao-mat?the=nhat-ky'],
];

/**
 * Chuyển một đường cũ của cổng tenant (`DUONG_CU_TENANT`), giữ đuôi, query và hash; `replace` như `ChuyenDuongCu`.
 * Query của đường mới (`?the=`) ghi đè query cùng tên của đường cũ.
 */
function ChuyenDuongCuTenant({ den }: { den: string }) {
  const duongDan = useDuongDan();
  const { '*': duoi } = useParams();
  const { search, hash } = useLocation();
  const [goc, queryDen] = den.split('?');
  const query = new URLSearchParams(search);
  new URLSearchParams(queryDen).forEach((gt, khoa) => query.set(khoa, gt));
  const chuoi = query.toString();
  return <Navigate to={`${duongDan(duoi ? `${goc}/${duoi}` : goc)}${chuoi ? `?${chuoi}` : ''}${hash}`} replace />;
}

/**
 * Route của **cổng tenant** — các nhóm nghiệp vụ.
 *
 * Đường dẫn gốc, chưa mang tiền tố. Xem `duoiTienTo()`.
 */
function routeNghiepVu(): RouteObject[] {
  return [
    { index: true, element: <DashboardView /> },
    // ADR-0123 — màn Token AI của tổ chức.
    { path: 'token-ai', element: <TokenAiView /> },
    { path: 'bao-cao', element: <BaoCaoView /> },
    { path: 'xu-ly/chung-tu', element: <ChungTuView /> },
    { path: 'xu-ly/nhan-dang', element: <ChonKhuonView /> },
    { path: 'xu-ly/nhan-dang/:schemaCode', element: <NhanDangView /> },
    /*
     * Module `ocr` (đợt 5): màn nối API thật `/api/v1/m/ocr/...` qua repository. Khai ở đây theo
     * tiền lệ của cổng tenant (chưa có registry riêng); khi host Module Federation có (`G2-D3-4`)
     * thì chuyển thành remote `modules/ocr/frontend/` và `menus` của manifest (ADR-0071).
     */
    { path: 'xu-ly/chung-tu/:docId', element: <ChiTietChungTuView /> },
    { path: 'xu-ly/tai-lieu-ocr', element: <KhoOcrView /> },
    { path: 'xu-ly/cau-hinh-ocr', element: <DanhSachLoaiChungTuView /> },
    { path: 'xu-ly/cau-hinh-ocr/:schemaId', element: <ChiTietLoaiChungTuView /> },
    // ADR-0059 mục 8 — cổng tenant chưa có registry riêng (xem `app/modules.ts`).
    { path: 'he-thong/bao-mat', element: <CaiDatBaoMatView /> },
    // ADR-0058 mục 8 "Phía khách": màn tự báo khi không phải bản on-premise.
    { path: 'he-thong/license', element: <LicenseCucBoView /> },
    { path: 'he-thong/nguoi-dung', element: <CauHinhNguoiDungView /> },
    { path: 'he-thong/vai-tro', element: <CauHinhVaiTroView /> },
    // ADR-0080 — module tham-dinh. Màn ở đây cho tới khi có remote Module Federation, cùng lý do với tri-thuc.
    // Bốn màn ngoài `tieu-chi` gọi route backend của đợt sau; chúng tự báo "chưa mở" thay vì dải lỗi.
    { path: 'tham-dinh', element: <TongQuanThamDinhView /> },
    { path: 'tham-dinh/ho-so', element: <HoSoThamDinhView /> },
    { path: 'tham-dinh/ho-so/:id', element: <ChiTietHoSoView /> },
    { path: 'tham-dinh/phe-duyet', element: <PheDuyetThamDinhView /> },
    { path: 'tham-dinh/tieu-chi', element: <ThuVienTieuChiView /> },
    { path: 'tham-dinh/tich-hop', element: <TichHopApiView /> },
    /*
     * Module eKYC: bốn màn. Quy trình định danh và Ứng dụng & khoá API vẫn rơi vào stub cho tới đợt sau.
     */
    { path: 'ekyc', element: <TongQuanEkycView /> },
    { path: 'ekyc/dinh-danh', element: <DinhDanhView /> },
    { path: 'ekyc/ho-so', element: <HoSoDinhDanhView /> },
    { path: 'ekyc/ho-so/:id', element: <ChiTietHoSoDinhDanhView /> },
    { path: 'ekyc/quy-trinh', element: <QuyTrinhView /> },
    { path: 'ekyc/ung-dung', element: <UngDungView /> },
    // ADR-0075 — module tri-thuc. Màn ở đây cho tới khi có remote Module Federation (G3-D3-3).
    { path: 'tri-thuc', element: <KhoTriThucView /> },
    { path: 'tri-thuc/kho/:id', element: <ChiTietKhoView /> },
    { path: 'tri-thuc/kiem-duyet', element: <KiemDuyetView /> },
    { path: 'tri-thuc/upload', element: <UploadTaiLieuView /> },
    // ADR-0068: khoá API của tổ chức (G2-D1-18).
    { path: 'he-thong/khoa-api', element: <KhoaApiView /> },
    { path: 'he-thong/canh-bao', element: <CanhBaoTenantView /> },
    { path: 'he-thong/dia-chi-rieng', element: <DiaChiRiengView /> },
    // G2-D1-17 (ADR-0014, ADR-0067): cây phòng ban của tổ chức.
    { path: 'he-thong/to-chuc', element: <CoCauToChucView /> },
    { path: 'xu-ly-van-ban/cau-hinh/dau-vao', element: <CauHinhDauVaoView /> },
    { path: 'xu-ly-van-ban/cau-hinh/mau-van-ban', element: <MauVanBanView /> },
    { path: 'xu-ly-van-ban/cau-hinh/vai-tro-cac-cap', element: <VaiTroCacCapView /> },
    /*
     * ADR-0081 — module bao-cao (Báo cáo doanh nghiệp). Màn ở đây cho tới khi có remote Module Federation
     * (G3-D3-3). Năm phân hệ là năm route tĩnh dùng chung `PhanHeView`; `key` theo slug để đổi phân hệ là
     * dựng lại màn, bản nháp của phân hệ này không bao giờ sang phân hệ kia.
     */
    ...SLUG_PHAN_HE.map((slug) => ({
      path: `bao-cao-doanh-nghiep/${slug}`,
      element: <PhanHeView key={slug} slug={slug} />,
    })),
    { path: 'bao-cao-doanh-nghiep/tai-lieu', element: <TaiLieuView /> },
    { path: 'bao-cao-doanh-nghiep/nguon', element: <NguonView /> },
    { path: 'xu-ly-van-ban/tom-tat', element: <TomTatView /> },
    { path: 'xu-ly-van-ban/soan-thao', element: <SoanThaoView /> },
    { path: 'xu-ly-van-ban/phan-cong', element: <PhanCongView /> },
    { path: 'xu-ly-van-ban/quan-ly-nhiem-vu', element: <QuanLyNhiemVuView /> },
    // Bản cũ: /thong-bao là bảng tin thông báo nhiệm vụ của người đang đăng nhập
    { path: 'thong-bao', element: <ThongBaoView /> },
    /*
     * ADR-0086 — module tro-ly-ai (Trợ lý AI). Màn ở đây cho tới khi có remote Module Federation (G3-D3-3), cùng lý
     * do với tham-dinh. Chỉ API thật, không có máy chủ giả.
     */
    { path: 'tro-ly-ai', element: <HoiDapView /> },
    { path: 'tro-ly-ai/tong-quan', element: <TongQuanTroLyView /> },
    { path: 'tro-ly-ai/tro-chuyen', element: <BotLuoiView /> },
    { path: 'tro-ly-ai/tro-chuyen/:botId', element: <BotChatView /> },
    { path: 'tro-ly-ai/ket-noi', element: <KetNoiView /> },
    { path: 'tro-ly-ai/ban-sao', element: <KhoDuLieuView /> },
    { path: 'tro-ly-ai/ban-sao/:nguon', element: <ReplicaView /> },
    { path: 'tro-ly-ai/khuon', element: <KhuonView /> },
    { path: 'tro-ly-ai/khuon/:nguon', element: <KhuonChiTietView /> },
    { path: 'tro-ly-ai/cong-cu-api', element: <ChuyenSangKhuon /> },
    { path: 'tro-ly-ai/chatbot', element: <ChatbotConfigView /> },
    { path: 'tro-ly-ai/quyen-du-lieu', element: <DataPermView /> },
    { path: 'tro-ly-ai/nhat-ky', element: <TracesView /> },
    { path: 'tro-ly-ai/thu-nghiem', element: <PlaygroundView /> },
    /*
     * ADR-0103 — module rpa (Quản lý RPA). Màn ở đây cho tới khi có remote Module Federation (G3-D3-3). Chỉ API
     * thật, không có máy chủ giả: dữ liệu nằm ở OpenCore của tenant.
     */
    { path: 'rpa', element: <TongQuanRpaView /> },
    { path: 'rpa/agent', element: <AgentRpaView /> },
    { path: 'rpa/projects', element: <ProjectView /> },
    { path: 'rpa/workflows', element: <WorkflowView /> },
    { path: 'rpa/alert-config', element: <CauHinhLoiView /> },
    { path: 'rpa/history', element: <LichSuView /> },
    { path: 'rpa/history/execution-data', element: <DuLieuThucThiView /> },
    { path: 'rpa/incidents', element: <SuCoView /> },
    { path: 'rpa/licenses', element: <LicenseView /> },
    { path: 'rpa/opencore-users', element: <UserOpenCoreView /> },
    // ADR-0096 — host Module Federation: màn của module đã cài, menu sinh từ `menus` của manifest.
    { path: 'm/:code/*', element: <ManHinhModuleView /> },
    // ADR-0096 mục 8 — màn Module: nộp gói, xem và cài module đã duyệt.
    { path: 'module', element: <ModuleToChucView /> },
    ...STUB_ROUTES.map(([path, khoa]) => ({
      path: path.slice(1),
      element: <StubPage khoa={khoa} />,
    })),
    ...placeholderRoutes().map((r) => ({ ...r, path: r.path!.slice(1) })),
    /*
     * Đường cũ của native: màn trò chuyện với một bot nay ở `tro-ly-ai/tro-chuyen/:botId`. Giữ để dấu trang không
     * thành 404 — người không có `ASSISTANT_CHATBOT` vẫn bị `PermissionGuard` chặn ở đường cũ trước khi chuyển.
     */
    { path: 'tro-ly-ai/chatbot/:botId', element: <ChuyenSangTroChuyen /> },
    ...DUONG_CU_TENANT.map<RouteObject>(([tu, den]) => ({ path: tu, element: <ChuyenDuongCuTenant den={den} /> })),
  ];
}

/**
 * Route của **cổng nền tảng** — sinh từ registry `app/modules.ts`, không khai
 * tay từng dòng. Thêm một mục ở registry là có ngay cả route danh sách lẫn
 * route chi tiết.
 */
function routeQuanTri(): RouteObject[] {
  return [
    { index: true, element: <VeModuleDauTien /> },
    ...MODULES.flatMap<RouteObject>((m) => [
      // Truyền thẳng `module`: đường dẫn ở đây là tường minh (`tenant`) chứ
      // không phải đoạn động, nên không có `useParams().moduleId` để tra
      // registry.
      { path: m.id, element: <RouteModule module={m} /> },
      ...(m.ComponentCon
        ? [{ path: `${m.id}/:${m.thamSo ?? 'ma'}`, element: <RouteModule module={m} con /> }]
        : []),
    ]),
    // Đường dẫn cũ của màn đã gộp, đổi tên — khai ở `DUONG_CU` của registry, không khai tay ở đây.
    ...DUONG_CU.flatMap<RouteObject>((d) => [
      { path: d.tu, element: <ChuyenDuongCu duong={d} /> },
      { path: `${d.tu}/*`, element: <ChuyenDuongCu duong={d} /> },
    ]),
  ];
}

/**
 * Gắn một danh sách route gốc xuống dưới tiền tố của cổng.
 *
 * Mỗi nhánh có `*` riêng: không có nó, một đường dẫn sai dưới `/client` sẽ rơi
 * xuống `*` ở gốc và bị `PhamViGuard` xử như đường dẫn chưa có tiền tố — tức
 * là chuyển hướng vòng thay vì hiện màn 404.
 */
function duoiTienTo(tienTo: string, routes: RouteObject[]): RouteObject {
  return {
    path: tienTo.slice(1),
    children: [...routes, { path: '*', element: <KhongTimThayPage /> }],
  };
}

export const router = createBrowserRouter([
  // Nhóm (auth): thẻ căn giữa, không có thanh điều hướng.
  {
    element: <GuestOnlyGate />,
    children: [
      {
        element: <AuthLayout />,
        children: [
          { path: '/dang-nhap', element: <DangNhapView /> },
          { path: '/quen-mat-khau', element: <StubPage khoa="route.quenMatKhau" /> },
          { path: '/dat-lai-mat-khau', element: <StubPage khoa="route.datLaiMatKhau" /> },
        ],
      },
    ],
  },

  // Nhóm (main): thanh điều hướng + vùng nội dung tự cuộn.
  {
    element: <AuthGate />,
    children: [
      {
        element: <MainLayout />,
        children: [
          /*
           * `/` trần không có route riêng: `PhamViGuard` bắt nó trước khi tới
           * đây và đưa sang gốc nhánh của người dùng (`/client` hoặc `/admin`).
           */

          // Hai nhánh của hai cổng.
          duoiTienTo(TIEN_TO['nen-tang'], routeQuanTri()),
          duoiTienTo(TIEN_TO.tenant, routeNghiepVu()),

          /*
           * "Tài khoản của tôi" (ADR-0027, ADR-0028): dùng chung hai cổng, ngoài
           * hệ tiền tố. Không vào registry `app/modules.ts` vì registry là màn
           * của một cổng, lọc theo quyền và hiện ở thanh điều hướng; màn này ai
           * đăng nhập cũng vào được, mở từ menu tài khoản.
           */
          { path: '/cai-dat', element: <TaiKhoanCuaToiView /> },
          { path: '/cai-dat/api-keys', element: <ChuaDungPage khoa="module.khoaApi.nhan" /> },
          // ADR-UI-0018: màn Giao diện, thay ngăn trượt cũ. Cũng dùng chung hai cổng.
          { path: '/giao-dien', element: <GiaoDienView /> },

          /*
           * Chốt cuối cho đường dẫn **chưa mang tiền tố** — dấu trang cũ,
           * liên kết trong email. `PhamViGuard` bắt chúng trước khi tới đây và
           * đưa về đúng nhánh, nên nhánh này chỉ còn phục vụ đường dẫn thật sự
           * không tồn tại.
           *
           * Không có nó, React Router dựng màn lỗi mặc định ("Unexpected
           * Application Error!" kèm lời nhắn cho lập trình viên) — thứ không
           * bao giờ được để người dùng cuối nhìn thấy.
           */
          { path: '*', element: <KhongTimThayPage /> },
        ],
      },
    ],
  },
]);
